import Layout from '@/layout';
var fifteenRouter = [
// 全国眼健康调查
{
  path: "/gov/search-file",
  component: Layout,
  name: 'fifteenProvincesFlow',
  meta: {
    title: '全国眼健康调查',
    icon: 'nav_functive',
    roles: ['fifteenadmin']
  },
  children: [{
    path: "/management",
    component: function component() {
      return import("@/views/h5/search-file/filedetail");
    },
    meta: {
      title: "档案管理",
      roles: ["fifteenadmin"]
    }
  }, {
    path: "/checkProgress",
    component: function component() {
      return import("@/views/h5/search-file/screenProcess");
    },
    meta: {
      title: "筛查进度",
      roles: ["fifteenadmin"]
    }
  }, {
    path: "/downloadfile",
    component: function component() {
      return import("@/views/h5/search-file/export");
    },
    meta: {
      title: "下载文件",
      roles: ["fifteenadmin"]
    }
  }]
}];
export default fifteenRouter;